import { DialogActions, DialogContent } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  Grid,
  IconButton,
  Typography,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { message } from 'antd';
import { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoginContext } from '../../contexts/LoginContext';
import { Header } from '../../MarketingSiteComponents/Header';
import getMedineerTestSeries from '../../services/medineerServices/getMedineerTestSeries';
import getAllSubscriptionsService from '../../services/OwnTestCreationServices/getAllSubscriptionsService';
import TestSeriesCard from '../../SplashScreens/TestSeriesCard';
import cardTemplateDescriptionsData from '../../staticDataTemplate.json';
import demoCardTemplateDescriptions from '../../staticDataTemplateDemoServer.json';
import styles from '../../styles/Home.module.css';
import CustomModal from '../CustomModal/CustomModal';
import TestDetailsPage from '../TestDetailsPage';
import NewSignUp from './NewSignUpForm';


function TestSeriesPage() {
  const location = useLocation();
  const hasFetchedRef = useRef(false);
  const isProduction = window.location.origin === "https://www.medineer.ai" || window.location.origin === "https://medineer.ai" ? true : false;
  const cardTemplateDescriptions = isProduction ? cardTemplateDescriptionsData : demoCardTemplateDescriptions
  const {
    //  objectives,
    subscriptions } = location.state;
  console.log(subscriptions, '- sublist')
  // let ids = [3, 2, 8, 7, 6, 11, 10, 9]; // hide one and two year courses
  // const coursesToHide = cardTemplateDescriptions.Cards
  //   .filter(x => x.isHidden == true)
  //   .map(x => x.ID);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const scrollRef = useRef(null);
  const [testSeries, setTestSeries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize] = useState(100);
  // const [objectives, setObjectives] = useState([]);
  const [objectiveFlag, setObjectiveFlag] = useState(null);
  const [activeButtonIndex, setActiveButtonIndex] = useState(null);
  const [showTestDetails, setShowTestDetails] = useState(null);

  const { contentCuratorIds, setContentCuratorIds } = useContext(LoginContext);
  // const fetchContentCuratorIds = async () => {
  //   try {
  //     let ids = contentCuratorIds;
  //     if (ids.length <= 0) {
  //       const data = await getProviderContentCuratorIds(configUrl.MediNeerProviderId);
  //       ids = data?.$values || [];
  //       setContentCuratorIds(ids);
  //     }
  //     axios.defaults.headers.common = {
  //       providerId: configUrl.MediNeerProviderId,
  //       contentProviderIds: ids,
  //     };
  //   } catch (error) {
  //     console.error("Error fetching content curator IDs:", error);
  //   }
  // };

  // const fetchTestSeries = async (page, objective) => {
  //   setLoading(true);
  //   // await fetchContentCuratorIds();
  //   try {
  //     const response = await axios.get(`${configUrl.AssessmentServer}/api/Courses`, {
  //       params: {
  //         pageNumber: page,
  //         pageSize: pageSize,
  //         contentFilter: 0,
  //         contentCuratorIds: null,
  //         objective: objective || null,
  //         isMedineerLogin: true
  //       }
  //     });
  //     console.log(response, 'resp')
  //     const seriesList = response?.data?.$values || [];;

  //     const totalItems = seriesList[0]?.totalCount || 0;
  //     setTestSeries(seriesList);
  //     setTotalPages(Math.ceil(totalItems / pageSize));
  //   } catch (error) {
  //     console.error("Error fetching test series:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchSeries = async (page, objective) => {
    setLoading(true);

    try {
      const { list, totalItems } = await getMedineerTestSeries({
        pageNumber: page,
        pageSize,
        objective,
      });

      // const filteredList = list?.length > 0 && list.filter(
      //   (x) => !coursesToHide.includes(x.courseId)
      // );
      setTestSeries(list);
      setTotalPages(Math.ceil(totalItems / pageSize));
    } catch (error) {
      console.error('Error fetching test series:', error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    // StrictMode + duplicate guard
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    fetchSeries(pageNumber, objectiveFlag);
  }, []);


  // useEffect(() => {
  //   if (objectives && objectives?.length > 0) {
  //     setTestSeries([]); // Clear previous series
  //     fetchTestSeries(1, objectiveFlag);
  //     if (pageNumber !== 1) {
  //       setPageNumber(1);
  //     }
  //   }
  // }, [objectiveFlag]);

  // const handlePageChange = (event, value) => {
  //   setPageNumber(value);
  // };
  const handlePageChange = (_, value) => {
    setPageNumber(value);
    fetchSeries(value, objectiveFlag);
  };


  const handleLearnMore = (ser, cardData) => {
    let series = { ...ser, ...cardData }
    navigate('/medineer/test-series-details', { state: { series } });
  };

  const handleEnroll = (series) => {
    console.log(series, '- serlog')
    if (
      series?.assingnedStudentsCount &&
      series?.testSeriesStudentsCount &&
      (series?.assingnedStudentsCount + 1) > series?.testSeriesStudentsCount
    ) {
      message.error("Please contact the admin.");
    } else {
      let ResourceTypeId = 3;
      navigate('/medineer/SignUp', { state: { series, ResourceTypeId } });
    }
  };


  const TestInfo = async (isPredictor) => {
    setShowTestDetails(
      <CustomModal
        modal={true}
        setModal={hideTestDetails}
        content={
          <TestDetailsPage
            subscription={subscriptions ?? null}
            showSignUpForm={() => showSignUpForm()}
          />
        }
        showOk={false}
        showCancel={false}
        onCancelClick={hideTestDetails}
        title={
          isMobile ?
            'Unlock 10 Tests @ ₹ 390!' :
            'Unlock 10 Topicwise Tests Just @ ₹ 390!'
        }
        maxWidth={"md"}
        hideTitle={true}
        fullWidth={false}
        isHeaderBackground={true}
      />
    )
  }
  const showSignUpForm = async () => {
    const subscriptions = await getAllSubscriptionsService();
    console.log("subscription data is ", subscriptions);
    const series = {
      "courseId": subscriptions[0]?.subscriptionTypeId ?? subscriptions?.courseId,  //passing default as 1 for now
      "price": subscriptions[0]?.price ?? 0,
    }
    setShowTestDetails(
      <Dialog
        fullWidth={false}
        maxWidth={'sm'}
        open={true}
        onClose={hideTestDetails}
      >
        {/* <DialogTitle> */}
        <Typography variant="h4" gutterBottom style={{ padding: '3% 2% 2% 9%', fontFamily: 'Poppins', color: '#002147', fontWeight: 'bold' }}>
          {"SIGN-UP"}
          <Button onClick={hideTestDetails} style={{ float: 'right', alignSelf: 'flex-end', color: 'black' }}><Close /></Button>
        </Typography>
        {/* </DialogTitle> */}
        <DialogContent>
          <NewSignUp
            seriesprops={series}
            ResourceTypeIdprops={4}
            isHideSignup={true}
          />
        </DialogContent>
        <DialogActions>

        </DialogActions>
      </Dialog>
    )
  }

  const onNextHandle = (series) => {
    let ResourceTypeId = 4;
    navigate('/medineer/SignUp', { state: { series, ResourceTypeId } });
  }
  const hideTestDetails = () => {
    setShowTestDetails(null);
  }
  // const handleNavigation = (series, index) => {
  //   // navigate(route);
  //   if (objectiveFlag == series?.id) {
  //     setActiveButtonIndex(null);
  //     setObjectiveFlag(null);
  //   } else {
  //     setActiveButtonIndex(index);
  //     setObjectiveFlag(series?.id);
  //   }
  // };
  const handleNavigation = (series, index) => {
    const newObjective =
      objectiveFlag === series?.id ? null : series?.id;

    setActiveButtonIndex(
      objectiveFlag === series?.id ? null : index
    );
    setObjectiveFlag(newObjective);

    setPageNumber(1);
    fetchSeries(1, newObjective);
  };


  const bestCoupen = (course) => {
    const availableCoupons = course?.coupons?.$values || [];
    const bestCoupon = availableCoupons?.length
      ? availableCoupons.reduce((prev, curr) =>
        (curr?.discountPercentage || 0) > (prev?.discountPercentage || 0) ? curr : prev
      )
      : null;
    return bestCoupon;
  }
  return (
    <div style={{ background: 'linear-gradient( 136deg, hsl(209 100% 18%), hsl(208 103% 20%))' }}>
      {/* <Header isTransperant={false} /> */}
      <Header />
      <Grid container justifyContent={'center'}
        sx={{
          // mt: '89px',
          marginTop: '5rem',
          // background: 'linear-gradient( 136deg, hsl(209 100% 18%), hsl(208 103% 20%))'
        }}
      >
        <Grid item xs={11} sm={12} className={styles.Rectangle22}>
          {/* <Box display="flex" justifyContent="start" flexWrap="wrap">
            <IconButton disabled={true} className={styles.filterButton}>
              <FilterAltIcon className={styles.filterIcon} />
            </IconButton>
            <span className={styles.filterLabel}>Filters </span>
            <Divider orientation="vertical" className={styles.dividerX} flexItem />

            {objectives && objectives?.length > 0 && objectives.map((series, index) => (
              <Button
                key={index}
                variant="contained"
                onClick={() => handleNavigation(series, index)}
                className={styles.filterButtonFonts}
                style={{
                  background: index == activeButtonIndex ? '#d5caf4' : '#efefef',
                  color: index == activeButtonIndex ? '#474747' : '#000000',
                  marginBottom: '10px', // Optional: space between buttons
                  marginRight: '10px', // Optional: space between buttons
                  width: 'auto', // Let the buttons shrink based on content
                  maxWidth: '100%', // Prevent buttons from overflowing
                  whiteSpace: 'normal', // Allow text to wrap inside button
                }}
              >
                {`${series.valueString}  ${index == activeButtonIndex ? 'X' : '  '}`}
              </Button>
            ))}
          </Box> */}
        </Grid>

        {/* <Box
              ref={scrollRef}
              sx={{
                display: 'flex',
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                '&::-webkit-scrollbar': { display: 'none' },
              }}
            > */}
        <Grid container spacing={0}>
          {loading ? (
            <Box sx={{ flex: '0 0 auto', width: 900, height: 200, m: 1, background: 'linear-gradient( 136deg, hsl(209 100% 18%), hsl(208 103% 20%))' }}>
              <CircularProgress sx={{ marginLeft: '50%', marginTop: '50%' }} />
            </Box>
          ) :
            testSeries?.length > 0 ?
              (
                testSeries.map((series, index) => {
                  // const cardData = cardTemplateDescriptions.Cards.find(card => card.ID === series.courseId);
                  // Derive the type
                  const seriesType = series.Type ? series.Type : "TestSeries";

                  // Match by ID + Type
                  const cardData = cardTemplateDescriptions.Cards.find(
                    card => card.ID === series.courseId && card.Type === seriesType
                  );
                  if (!cardData?.isActive) return null;   //display only isActive Courses

                  const cardDescription = cardData
                    ? cardData.CardBulletPoints
                    : cardTemplateDescriptions.Cards[0]?.CardBulletPoints || ["No details available"];

                  return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      {/* // <Box key={index} sx={{ flex: '0 0 auto', width: 400, m: 1 }}> */}
                      <TestSeriesCard
                        title={series?.text || series?.courseName}
                        description={series?.description}
                        image={series?.image || '/Gemini_image_not_available.jpg'}
                        bulletPoints={series?.bulletPoints}
                        price={series?.price || 0}
                        onLearnMore={() => handleLearnMore(series, cardData)}
                        onEnroll={() => handleEnroll(series)}
                        bestCoupen={bestCoupen(series)?.discountPercentage}
                        testsCount={series?.testCount || 0}
                        duration={series?.duration}
                        courseId={series?.courseId}
                        isMargin={true}
                        discountAmmt={cardData?.originalPrice}
                        testSeriesStudentsCount={series?.assingnedStudentsCount || 0}
                        TagOnCard={cardData ? cardData.TagOnCard : ''}
                        SubjectTagOnCard={cardData ? cardData.SubjectTagOnCard : ''}
                        FreeCPTag={cardData ? cardData.FreeCPTag : ''}
                        isHideStudentIcon={true}
                        isTestSeriesList={true}
                        fontSize={12}
                        isShowIncludeBullet={cardData.isShowIncludeBullet}
                        cardDescription={
                          <ul style={{ listStyleType: 'none', paddingLeft: 0, marginBottom: 0 }}>
                            {cardDescription && cardDescription.map((point, idx) => (
                              <li key={idx}><span style={{ marginRight: '8px', color: 'green' }}>✓</span>{point}</li>
                            ))}
                          </ul>
                        }
                      />
                      {/* // </Box> */}
                    </Grid>
                  );
                })
              )
              : (
                <Box sx={{ width: '100%', textAlign: 'center', mt: 5 }}>
                  <h4>No test series found.</h4>
                </Box>
              )
          }
          {/* {!loading && 
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <TestSeriesCard
              title={'Pick Your Test'}
              description={'Description'}
              image={'/Gemini_image_not_available.jpg'}
              bulletPoints={'series?.bulletPoints'}
              price={subscriptions?.price}
              onLearnMore={() => TestInfo()}
              onEnroll={() => onNextHandle(
                subscriptions
              )}
              testsCount={subscriptions?.testCount}
              duration={subscriptions?.duration}
              courseId={subscriptions?.subscriptionTypeId}
              isMargin={true}
              isHideStudentIcon={true}
              actionButtonText={'Sign Up'}
            />
          </Grid>} */}



        </Grid>
        {/* </Box> */}
      </Grid >
      <Grid container justifyContent={'center'}>
        <Grid item sm={12} md={12} lg={11}>
          {!loading && <Alert
            severity="info"
            icon={false}
            sx={{
              background: 'linear-gradient(to right, #3949ab, #5c6bc0)', // Inspired by header colors
              color: '#fff',
              fontWeight: 500,
              fontSize: '1.5rem',
              borderRadius: '10px',
              // mb: 2,
              mt: '45px',
              mb: '45px',
              padding: '10px 20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
            }}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="medium"
                onClick={() => {
                  console.log('CP')
                }}
                sx={{ position: 'absolute', top: 6, right: 8 }}
              >
              </IconButton>
            }
          >
            <span>🎯 Maximize your prep with expert-designed tests and smart insights — <b>Unlock 10 tests for just ₹390! Sign up now!</b>&nbsp;</span>
            <Button
              variant="outlined"
              sx={{
                borderColor: '#fff',
                color: 'black',
                fontSize: "1.3rem",
                fontWeight: 600,
                textTransform: 'none',
                ml: 1,
                backgroundColor: '#f8cb1e',
                '&:hover': {
                  backgroundColor: '#c9bb88',
                  borderColor: '#fff',
                },
              }}
              onClick={() => TestInfo()}  // or navigate("/college-predictor")
            >
              Know More
            </Button>
          </Alert>}
        </Grid>
      </Grid>
      {
        showTestDetails
      }
    </div>
  );
}

export default TestSeriesPage;
